import { makeAutoObservable } from 'mobx';
import { TariffPlanPurchase } from '@type/tariffPlanPurchase';
import { tariffPlanPurchaseService } from '@api/services/tariffPlanPurchaseService';
import dayjs from 'dayjs';

export type UserPurchases = {
  // undefined - данные еще не загружены
  active: TariffPlanPurchase[] | undefined;
  expired: TariffPlanPurchase[] | undefined;
  current: TariffPlanPurchase | null | undefined;
};

class TariffPlanPurchaseStore {
  tariffPlanPurchases: UserPurchases = {
    active: undefined,
    expired: undefined,
    current: undefined,
  };

  isListLoading = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setIsListLoading = (value: boolean) => (this.isListLoading = value);

  setTariffPlanPurchases = (value: TariffPlanPurchase[]) => {
    const now = dayjs();

    const result: UserPurchases = {
      active: [],
      expired: [],
      current: null,
    };

    value.forEach((purchase) => {
      const isExpired = now.isAfter(dayjs(purchase.expires_at)) || purchase.remaining_balance <= 0;

      isExpired ? result.expired!.push(purchase) : result.active!.push(purchase);
    });

    result.current = result.active?.at(-1) || null;

    this.tariffPlanPurchases = result;
  };

  async loadList(userId?: string) {
    if (this.isListLoading) return;

    this.setIsListLoading(true);
    try {
      const { data } = await tariffPlanPurchaseService.getList(userId);
      this.setTariffPlanPurchases(data);
      return this.tariffPlanPurchases;
    } catch (error) {
      console.error(error);
    } finally {
      this.setIsListLoading(false);
    }
  }

  async createPurchase({ tariffPlanId, userId }: { tariffPlanId: string; userId: string }) {
    try {
      const { data } = await tariffPlanPurchaseService.create({
        tariffPlanId,
        userId: userId,
      });

      this.tariffPlanPurchases.active?.unshift(data);
    } catch (error) {
      console.error(error);
    }
  }

  async deletePurchase(purchaseId: string) {
    try {
      await tariffPlanPurchaseService.delete(purchaseId);
      this.tariffPlanPurchases.active = this.tariffPlanPurchases.active?.filter(
        (p) => p.id !== purchaseId,
      );
    } catch (error) {
      console.error(error);
    }
  }
}

export const tariffPlanPurchaseStore = new TariffPlanPurchaseStore();
